angular.module('rjmNg.controllers').controller('FileUploadCtrl', [
  "$scope"
  "$url"
  "$q"
  "$timeout"
  "fileUploadService"
  "notification"
  "$clientAppUrl"
  (
    $scope
    $url
    $q
    $timeout
    fileUploadService
    notification
    $clientAppUrl
  ) ->

    $scope.connectionsPageUrl = $clientAppUrl('/settings/connection/')

    $scope.pageNumber = 1
    $scope.pageLimit = 10
    $scope.files = []
    $scope.tables = []
    $scope.pages = []
    $scope.downloading = null
    $scope.loading = true
    $scope.baseUrl = $url("")
    $scope.addPopovers = () ->
      $timeout( -> $('.popover-description').popover() )

    $scope.downloadFile = (file) ->
      status = notification.info("Downloading!", "Preparing "+file.name+" for download, please wait.", "global")
      fileUploadService.download(file).then( (result) ->
        notification.remove(status, "global")
      ).catch( (error) ->
        notification.remove(status, "global")
        notification.error(error, "There was an error downloading that file. Please contact support.", "global")
      )

    # ON COMPLETION, SET UP THE UI
    $q.all([fileUploadService.listFiles(), fileUploadService.listTables()]).then( (promises) ->
      $scope.loading = false
      $scope.files = promises[0].data
      $scope.tables = promises[1].data
      $scope.addPopovers()
    , (error) ->
      $scope.loading = false
      notification.error("Error!", "Failed to pull some data from the server. Please contact support.", "global")
    )
    # DONE SETTING UP UI

    $scope.$watch 'pageNumber', (newPageNumber, oldnewPageNumber) ->
      if newPageNumber isnt oldnewPageNumber
        $scope.addPopovers()
])
